import styled from 'styled-components'
import InputMask from 'react-input-mask'
import { theme } from './../../common'
import { Button } from './../../components'

export const StyledInput = styled.input`
    width: 100%;
    border: 1px solid #DDDDDD;
    padding: 10px;
`
export const StyledInputMask = styled(InputMask)`
    width: 100%;
    border: 1px solid #DDDDDD;
    padding: 10px;
`
export const StyledTitle = styled.h1`
    font-size: 3em;
    font-weight: bold;
    text-transform: uppercase;
`

export const StyledSubtitle = styled.h2`
    font-size: 2em;
`
export const StyledError = styled.p`
    margin: 0px;
    color: red;
    font-size: 80%;
    position: absolute;
    bottom: ${({bottom}) => bottom ? `${bottom}%` : '-40%'};
`
export const StyledTextarea = styled.textarea`
    width: 100%;
    border: 1px solid #DDDDDD;
    padding: 10px;
`